<template>
    <div>
      <h2>메시지관리</h2>
      <p>
        학생 개별 메시지는 홈화면에서 발송합니다.<br/>
        반별, 학교별 또는 개별 학생을 묶어서 한번에 발송할 경우 메시지관리의 메시지전송 기능을 사용합니다.<br/>
      </p>
      <div class="p-relative section_0">
          <div class="p-relative section_2">
              <div><img src="@/assets/aca/manual/staff/staff_message_info.jpg" /></div>
          </div>

          <div class="p-relative section_1">
            - 메시지 관리는 크게 2부분으로 나눕니다. <br/>
              1) 발송대상학생입력 2) 메시지입력 및 발송
          </div>
      </div>
      <p></p>
      <section>
        <div class="p-relative section_0" id="select_all">
            <div class="ft-b">1)    발송대상학생입력</div>
        
            <div class="p-relative section_1">
                -   대상학생을 재원생/퇴원생/대기생/학년별로 구분하여 문자를 보낼 수 있습니다.
            </div>
            <div class="p-relative section_2">
                “전체”탭을 선택합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_message_select_all.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   대상학생을 반별로 구분하여 문자를 보낼 수 있습니다.
            </div>
            <div class="p-relative section_2">
                “반별”탭을 선택합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_message_select_class.jpg" /></div>
            </div>
            
            <div class="p-relative section_1">
                -   대상학생을 학교별로 구분하여 문자를 보낼 수 있습니다. 
            </div>
            <div class="p-relative section_2">
                “학교별”탭을 선택합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_message_select_school.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   대상학생을 개별로 선택하여 문자를 보낼 수 있습니다.
            </div>
            <div class="p-relative section_2">
                “개별”탭을 선택합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_message_select_personal.jpg" /></div>
            </div>

            <div class="p-relative section_2">
                경우에 따라서<br/>
                학원에 등록되지 않은 학생에게 문자를 보내고 싶은 경우는<br/>
            </div>
            <div class="p-relative section_2">
                “대상학생 직접추가” 버튼을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_message_select_other.jpg" /></div>
            </div>

            <div class="p-relative section_2">
                “발송대상학생 정보입력” 다이알로그가 나타나면 학생이름과 전화번호를 입력하여 문자메시지를 보낼 학생을 직접 추가할 수 있습니다.
            </div>
            <div class="p-relative section_1">
                -   대상학생이 추가되면 아래 그림과 같이 나타납니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_message_select_result.jpg" /></div>
            </div>
        </div>


        <p></p>
        <div class="p-relative section_0" id="send_message">
            <div class="ft-b">2)    메시지입력 및 발송</div>
        
            <div class="p-relative section_1">
                -   발송대상학생이 추가되었다면 문자메시지를 추가하고 메시지를 전송합니다.
            </div>
            
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_message_send.jpg" /></div>
            </div>
        </div>
        
      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '발송대상학생입력', link: '#select_all' },
                { label: '메시지입력 및 발송', link: '#send_message' },
                
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


